import { Chip, type ChipProps, Focusable, Tooltip } from '@cfa/react-core';

import { type getDueDateColor } from '@/utils/dueDate';

type DueDateColor = ReturnType<typeof getDueDateColor>;

const CHIP_COLOR = {
  darkGreen: 'darkGreen',
  purple: 'purple',
  tan: 'cream',
} as const satisfies Record<DueDateColor, ChipProps['color']>;

interface PlanCardTagProps {
  color: DueDateColor;
  text: string;
  tooltip?: React.ReactNode;
}

const PlanCardTag: React.FC<PlanCardTagProps> = ({ color, text, tooltip }) => {
  const chip = (
    <Chip
      className="text-nowrap"
      color={CHIP_COLOR[color]}
      data-testid="DateTag"
      variant="filled"
    >
      {text}
    </Chip>
  );

  return tooltip ? (
    <Tooltip.Root delay={250}>
      <Focusable>{chip}</Focusable>
      <Tooltip.Content placement="top">{tooltip}</Tooltip.Content>
    </Tooltip.Root>
  ) : (
    chip
  );
};

export default PlanCardTag;
